import * as React from "react";
import {Select} from "antd";
import locales from "../locales";

const {Option} = Select;

export enum ChecklistRentTypeFilter {
  RENTAL = 'rentalOnly',
  RETURNAL = 'returnalOnly',
}

export const getChecklistFilterOptions = (): React.ReactNode[] => [
  getOption(locales.checklist_show_rental, ChecklistRentTypeFilter.RENTAL),
  getOption(locales.checklist_show_returnal, ChecklistRentTypeFilter.RETURNAL),
];

const getOption = (label: string, value: ChecklistRentTypeFilter): React.ReactNode => (
  <Option value={value} key={value}>{label}</Option>
);


// WEBPACK FOOTER //
// ./src/checklist-alerts/ChecklistRentTypeFilter.tsx